import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Calificaciones from "./Calificaciones";
import EstudiantesList from "./EstudiantesList";
import DatAcademicos from "./DatAcademicos";
import Calendario from "./Calendario";
import Cierre from "./Cierre";
import DatosEstadisticos from "../Opciones/DatosEstadisticos";
import ListAdmision from "../AdmisionAdmin/AdmisionAdminContent/ListAdmision";
import ListCarrera from "../Administracion/ReinscripcionesContent/ListCarrera";

class MainAcademicos extends Component {
    state = {
        valorRegistro: { value: 'calificaciones', label: 'Calificaciones' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/academicos/calificaciones": return({ value: 'calificaciones', label: 'Calificaciones' })
            case "/academicos/list_estudiantes": return({ value: 'list_estudiantes', label: 'Listado de Estudiantes' })
            case "/academicos/dat_academicos": return({ value: 'dat_academicos', label: 'Datos Académicos' })
            case "/academicos/calendario": return({ value: 'calendario', label: 'Calendario Académico' })
            case "/academicos/estadisticas": return({ value: 'estadisticas', label: 'Datos Estadísticos' })
            case "/academicos/cerrar_periodo": return({ value: 'cerrar_periodo', label: 'Cerrar Periodo Académico' })
            case "/academicos/list_nuevo_ingreso": return({ value: 'list_nuevo_ingreso', label: 'Nuevo Ingreso' })
            case "/academicos/list_est_carrera": return({ value: 'list_est_carrera', label: 'Estudiantes por Carrera' })
            default: return({ value: 'calificaciones', label: 'Calificaciones' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/academicos/calificaciones": return('Calificaciones')
            case "/academicos/list_estudiantes": return('Listado de Estudiantes')
            case "/academicos/dat_academicos": return('Datos Académicos')
            case "/academicos/calendario": return('Calendario Académico')
            case "/academicos/estadisticas": return('Datos Estadísticos')
            case "/academicos/cerrar_periodo": return('Cerrar Periodo Académico')
            case "/academicos/list_nuevo_ingreso": return('Nuevo Ingreso')
            case "/academicos/list_est_carrera": return('Estudiantes por Carrera')
            default: return('Calificaciones')
        }
    }

    valorSelectRegistro = (valorRegistro) => {
        this.setState({
            valorRegistro
        },() => {
            this.props.history.push(`/academicos/${this.state.valorRegistro.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/academicos/calificaciones" component={ () => <Calificaciones/> } />
                <Route path="/academicos/list_estudiantes" component={ () => <EstudiantesList/> } />
                <Route path="/academicos/dat_academicos" component={ () => <DatAcademicos/> } />
                <Route path="/academicos/calendario" component={ () => <Calendario/> } />
                <Route path="/academicos/estadisticas" component={ () => <DatosEstadisticos/> } />
                <Route path="/academicos/cerrar_periodo" component={ () => <Cierre/> } />
                <Route path="/academicos/list_nuevo_ingreso" component={ () => <ListAdmision estCuenta = {false}/> } />
                <Route path="/academicos/list_est_carrera" component={ () => <ListCarrera estCuenta = {false}/> } />
                <Redirect to = "/academicos/calificaciones" />
            </Switch>
        )
    }

    render() {
        const Registros = [
            { value: 'calificaciones', label: 'Calificaciones' },
            { value: 'list_estudiantes', label: 'Listado de Estudiantes' },
            { value: 'list_nuevo_ingreso', label: 'Nuevo Ingreso' },
            { value: 'list_est_carrera', label: 'Estudiantes por Carrera' },
            /* { value: 'dat_academicos', label: 'Datos Académicos' }, */
            { value: 'calendario', label: 'Calendario Académico' },
            { value: 'estadisticas', label: 'Datos Estadísticos' },
            { value: 'cerrar_periodo', label: 'Cerrar Periodo Académico' },
        ];
        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Registro
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectRegistro}
                                    options={Registros}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainAcademicos;


// WEBPACK FOOTER //
// ./src/views/Academicos/MainAcademicos.jsx